<script lang="ts">
  import { Col, Form, Image, Input, Row } from "sveltestrap";
  import { InvoiceLegal } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/other-images"
</script>
<Row class="mt-3"> 
  <Col md="8">
    <div>
      <p class="legal">{@html InvoiceLegal}</p>
    </div>
  </Col>
  <Col md="4">
    <Form class="text-end invo-pal">
      <Image src="{imgPath}/paypal.png" name="submit" alt="PayPal" />
    </Form>
  </Col>
</Row>